<template>
    <div class="row">
        <div class="col">
            <h3>About your current vehicle</h3>
            <div class="form">
                <div class="row row__vehicle_details">
                    <div class="col-sm col-md-6">
                        <label>Annual mileage</label>
                        <div class="pretty-input input-group mb-3">
                            <input :value="mileage" @complete="onMileageComplete"
                                   v-imask="mileageMask" type="text" id="diePrice"/>
                        </div>
                        <span class="error" v-if="mileageError">{{mileageError}}</span>
                    </div>
                    <div class="col-sm col-md-6">
                        <label>What fuel do you use?</label>
                        <div class="pretty-select input-group mb-3">
                            <select v-model="fuelType">
                                <option value="petrol">Petrol</option>
                                <option value="diesel">Diesel</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {FUEL_TYPE, REMOVE_ERROR} from "../store/mutation-types";
    import {MILEAGE_VALID} from "../store/action-types";
    import {IMaskDirective} from 'vue-imask'

    export default {
        name: "CurrentVehicle",
        data() {
            return {
                mileageMask: {
                    mask: Number,
                    scale: 0,
                    signed: false,
                    thousandsSeparator: ',',
                    padFractionalZeros: false,
                    normalizeZeros: false,
                    radix: '.',
                    mapToRadix: ['.'],
                    min: 1000,
                    max: 100000,
                },
            }
        },
        computed: {
            fuelType: {
                get: function(){
                    return this.$store.state.FUEL_TYPE
                },
                set: function(value){
                    this.$store.commit(FUEL_TYPE, value)
                }
            },
            mileage: function() {
                    return this.$store.state.MILEAGE
            },
            mileageError: function () {
                if (this.$store.state.ERRORS.mileage) {
                    return this.$store.state.ERRORS.mileage;
                }
                return false;
            }
        },
        methods: {
            onMileageComplete: function(e) {
                this.$store.dispatch(MILEAGE_VALID, e.detail.unmaskedValue);
            }
        },
        directives: {
            imask: IMaskDirective
        },
        watch: {
            fuelType: function() {
                this.$store.commit(REMOVE_ERROR, 'petrol');
                this.$store.commit(REMOVE_ERROR, 'diesel');
            }
        }
    }
</script>

<style scoped lang="stylus">
h3
    margin-top 0
.form
    margin-right 0
    flex-direction column
    flex-wrap nowrap
    .row
        &__vehicle_details
            margin-bottom 0.5 rem
    .pretty-select
        border solid 1px $color-grey-border
        background-color $color-white
        &:after
            background-image url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='15' height='9' viewBox='0 0 15 9'%3E%3Cpath fill='%23004666' fill-rule='nonzero' d='M1.588.03l5.883 5.882L13.41-.03l1.56 1.558-7.5 7.5L.029 1.59 1.59.028z'/%3E%3C/svg%3E")
            background-color $color-white
            background-repeat no-repeat
            background-position 50% 50%
    .pretty-input
        border solid 1px $color-grey-border
        input
            width 100%
            height 44px
            border none
            text-align right
            padding-right 1rem
            font-family $font-regular
            color $color-font

    .error
        margin-top 1rem
        color $color-red
        font-size 1.3rem
</style>